import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { EntityRatingCommentCount, Professional } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import { EntityProfileActions } from '@/app/(main)/(pages)/_components/entities/entity-profile-actions.component';
import { EntityProfileHeader } from '@/app/(main)/(pages)/_components/entities/entity-profile-header.component';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface ProfessionalHeaderProps {
  professional: Professional;
  commentsCount?: EntityRatingCommentCount | null;
  shouldAddLightbox?: boolean;
  specialties?: ReactNode;
  scheduleAction?: ReactNode;
}

export function ProfessionalHeader({
  professional,
  commentsCount,
  shouldAddLightbox = false,
  specialties,
  scheduleAction,
}: ProfessionalHeaderProps) {
  return (
    <EntityProfileHeader
      dataTestId={DataTestIdEnum.PROFESSIONAL_PROFILE_HEADER}
      name={professionalDisplayName({ honorific: professional.honorific ?? '', name: professional.name ?? '' })}
      subtitle={specialties}
      rating={professional.rating}
      commentsCount={commentsCount}
      ratingAnalyticsEvent={AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_REVIEWS_WITH_COMMENT}
      avatar={(
        <EntityAvatar
          src={professional.avatar as string}
          size="xxxl"
          alt={`Foto de perfil de ${professional.name}`}
          shouldAddLightbox={shouldAddLightbox}
          type={EntityTypeEnum.PROFESSIONAL}
          dataTestId={professional.avatar
            ? DataTestIdEnum.PROFESSIONAL_PROFILE_AVATAR
            : DataTestIdEnum.PROFESSIONAL_PROFILE_AVATAR_DEFAULT}
          data-analytics-event={AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_AVATAR}
        />
      )}
      actions={(
        <EntityProfileActions
          entityType={EntityTypeEnum.PROFESSIONAL}
          entity={professional}
          scheduleAction={scheduleAction}
        />
      )}
    />
  );
}
